export default {
    humanway_main_url: 'https://hw-elite-dev.vbote.com',
 		humanway_service_url : 'https://hw-elite-dev.vbote.com/api/v1/',
    humanway_gtag_id: 'X-XXXXXXXXXX',
version : '1.0.113' ,
};